import {
  chakra,
  type BreadcrumbLinkProps as ChakraBreadcrumbLinkProps,
} from '@chakra-ui/react-v2';
import { cx } from '@chakra-ui/utils';
import { forwardRef } from 'react';

import { useBreadcrumbStyles } from './context';

export type BreadcrumbLinkProps = ChakraBreadcrumbLinkProps & {
  isCurrentPage?: boolean;
};

export const BreadcrumbLink = forwardRef<'a' | 'span', BreadcrumbLinkProps>(
  function BreadcrumbLink(props, ref) {
    const { isCurrentPage, as, className, href, ...rest } = props;
    const styles = useBreadcrumbStyles();

    const sharedProps = {
      ref,
      as,
      className: cx('breadcrumb__link', className),
      ...rest,
    };

    if (isCurrentPage) {
      return (
        <chakra.span aria-current="page" __css={styles.link} {...sharedProps} />
      );
    }

    return <chakra.a __css={styles.link} href={href} {...sharedProps} />;
  },
);
BreadcrumbLink.displayName = 'BreadcrumbLink';
